import axiosHttp from "services/axiosHttp";
import { message } from "antd";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const checkinGatepass = createAsyncThunk(
	"checkinGatepass",
	async (id, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put(`gatepass/checkinpeople/${id}`);
			message.success(response.data?.message || "Person checked in successfully");
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			message.error(err.response.data?.message || "Failed to checkin person");
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassCheckinSlice = createSlice({
	name: "GatepassCheckinSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	reducers: {
		resetGatepassCheckin: (state) => {
			state.isLoading = false;
			state.data = null;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(checkinGatepass.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(checkinGatepass.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(checkinGatepass.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export const { resetGatepassCheckin } = GatepassCheckinSlice.actions;
export default GatepassCheckinSlice.reducer;
